export default function Search({width = 21, height = 21, className = ""}) {
    return (
        <img
            className={className}
            src="/assets/icons/search.svg"
            width={width}
            height={height}
            alt="hashguys question mark"
        />
    );
}